"use strict";

global.WtcpJs = global.WtcpJs || {};

(function() {
    let doc;
    let decoder;
    let loggingLevels = {
        none: 0,
        error: 1,
        warn: 2,
        debug: 3,
        info: 4
    };

    let baseLogMsg = 'WtcpJs:';

    try {
        doc = document;
    } catch (e) {
        doc = undefined;
    }

    var scriptPath = '';
    if (doc) {
        var scriptEls = doc.getElementsByTagName('script');
        var thisScriptEl = scriptEls[scriptEls.length - 1];
        var scriptSrc = thisScriptEl.src;
        scriptPath = scriptSrc.substr(0, scriptSrc.lastIndexOf('/') + 1);
    }

    // Detect Endianness
    var littleEndian = (function() {
        var buffer = new ArrayBuffer(2);
        new DataView(buffer).setInt16(0, 256, true);
        return new Int16Array(buffer)[0] === 256;
    })();

    //let wtcpLog = Symbol('wtcpLog');

    var WtcpUtil = function() {

        this.logLevel = 0;

        // Public properties
        Object.defineProperty(this, "Path", { get: function() { return scriptPath; } });
        Object.defineProperty(this, "LittleEndian", { get: function() { return littleEndian; } });
    };

    // default to 'info' - 3. If we don't specify or bad value, get as much info as possible
    WtcpUtil.prototype.setLoggingLevel = function (value) {
        if (!Number.isInteger(value))
            value = value in loggingLevels ? loggingLevels[value] : 4; // default to 'info'

        this.logLevel = value < 0 ? 0 : value > 4 ? 4 : value; // 0 <= logLevel <= 3
    }

    function formatLogMsg(fn, msg, args) {
        fn.call(console, `${baseLogMsg} ${msg}`, args);
    }

    WtcpUtil.prototype.wtcpInfo = function(e, ...args) {
        if (this.logLevel >= loggingLevels.info)
            formatLogMsg(console.info, e, args);
    }

    WtcpUtil.prototype.wtcpDebug = function(e, ...args) {
        if(this.logLevel >= loggingLevels.debug)
            formatLogMsg(console.debug, e, args);
    }

    WtcpUtil.prototype.wtcpWarn = function(e, ...args) {
        if (this.logLevel >= loggingLevels.warn)
            formatLogMsg(console.warn, e, args);
    }

    WtcpUtil.prototype.wtcpError = function(e, ...args) {
        if(this.logLevel >= loggingLevels.error)
            formatLogMsg(console.error, e, args);
    }

    var messages = '';

    WtcpUtil.prototype.debugWindow = function(messageClass, message) {
        var date = new Date();
        var time = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + "." + date.getMilliseconds();
        messages += time + " | " + messageClass + ":  " + message + "\n";

        //doc.getElementById("debugMessageWindow").innerText = messages;
    };

    WtcpUtil.prototype.loadScript = function(filename, callback) {
        if (doc !== undefined) {
            var scriptElem = doc.createElement('script');
            scriptElem.setAttribute("type", "text/javascript");
            scriptElem.setAttribute("src", filename);
            scriptElem.onload = function(e) {
                if (callback)
                    callback.call(this, e);
            };
            scriptElem.onerror = function(e) {
                if (callback)
                    callback.call(this, e);
            }
            doc.getElementsByTagName("head")[0].appendChild(scriptElem);
        } else {
            throw "Use importScripts from Web Workers, loadScript only works from UI thread";
        }
    };

    WtcpUtil.prototype.getScriptPath = function() {
        return scriptPath;
    };

    WtcpUtil.prototype.byteWriter = function(view, val, length, offset) {
        //only use this for tiny, short, or int (length 1, 2, or 4)
        //doesn't work for setting negative values
        //needs a lot of work, need to switch to using dataview??
        var shift;
        if (!offset)
            offset = 0;

        var n = offset + length;

        for (var x = offset; x < n; x++) {
            shift = ((n - (x + 1)) * 8);
            if (x === offset)
                view[x] = val >>> shift;
            else
                view[x] = (val >>> shift) ^ (view[x - 1] << 8);
        }
    };

    WtcpUtil.prototype.stringReader = function(data, position) {
        ///<summary>Gets the UTF-8 string value from byte stream at specified position</summary>
        ///<param name="view" type="ArrayBuffer"></param>
        ///<param name="position" type="Number">Numeric position from beginning of ArrayBuffer to start reading</param>
        ///<returns type="Number or Object">returns {string: 'text', str_terminate: position}</returns>
        try {
            decoder = new TextDecoder("utf-8");
        } catch (e) {
            //TBD: Works in Chrome, but need to add poly-fill or use existing library if not defined
            throw "browser does not support TextDecoder";
        }

        var i;
        var str = "";

        try {

            var view = new Uint8Array(data);

            for (i = position; i < view.length; i++) {
                if (view[i] === 0)
                    break;
            }

            var strView = new Uint8Array(data, position, i - position);

            str = decoder.decode(strView);

        } catch (exc) {
            this.wtcpError("Error decoding UTF-8 string", exc);
        }

        return { value: str, position: i };
    };

    WtcpUtil.prototype.byteReader = function(view, length, offset) {
        ///<summary>Retrieve value from byte stream at specified offset and length</summary>
        ///<param name="view" type="ArrayBufferView"></param>
        ///<param name="length" type="Number">Number of bytes to read</param>
        ///<param name="offset" type="Number">Numeric offset from beginning of ArrayBufferView to start reading</param>
        ///<returns type="Number or Object">returns numeric value</returns>

        var n = length + offset;
        var val = 0, shift;
        for (var x = offset; x < n; x++) {
            shift = ((n - (x + 1)) * 8);
            val += view[x] << shift;
        }
        return val;
    };

    WtcpUtil.prototype.addBitrange = function(val, valToAdd, bitLength, lshBytes) {
        ///<summary>Isolates a bit range from value</summary>
        ///<param name="val" type="Number">Value to add to</param>
        ///<param name="valToAdd" type="Number">Value to add</param>
        ///<param name="bitLength" type="Number">Number of bits to write</param>
        ///<param name="numBytes" type="Number">Byte length of value (1 for INT8, 2 for INT16, etc...)</param>
        ///<returns type="Number"></returns>

        if (valToAdd > (Math.pow(2, bitLength) - 1))
            throw `value is too great for the bitLength specified: ${valToAdd} > ${(Math.pow(2, bitLength) - 1)} for bitlength ${bitLength}`;

        valToAdd = valToAdd << (lshBytes * 8);
        val |= valToAdd;

        return val;
    };

    WtcpUtil.prototype.mergeArrayBuffers = function(bufferInfo1, bufferInfo2) {
        ///<summary>Merge two array buffers</summary>
        ///<param name="bufferInfo1" type="Object">{buffer: ArrayBuffer, offset: Int}</param>
        ///<param name="bufferInfo2" type="Object">{buffer: ArrayBuffer, offset: Int}</param>
        ///<returns type="ArrayBuffer"></returns>
        var ta = new Int8Array(bufferInfo1.buffer, bufferInfo1.offset);
        var tb = new Int8Array(bufferInfo2.buffer, bufferInfo2.offset);
        var n = new Int8Array(ta.length + tb.length);
        n.set(ta);
        n.set(tb, (ta.length - bufferInfo1.offset));

        return n.buffer;
    };

    /**
     * bitwise reader for extracting bit ranges from a TypedArray value
     * @param {Number} val - numeric value to extract bit range from 
     * @param {Number} bitPos - bit position to start reading 
     * @param {Number} bitLength - total number of bits to read 
     * @param {Number} numBytes - byte length of value (1 for INT8, 2 for INT16, etc...)
     * @returns {Number} 
     */
    WtcpUtil.prototype.bitReader = function(val, bitPos, bitLength, numBytes) {
        var totalBits = (numBytes * 8) - 1;

        let n = totalBits;

        while (n > bitPos) {
            val = val & ~(1 << n--);
        }
        val = val >>> (bitPos - bitLength) + 1;

        return val;
    };

    WtcpUtil.prototype.parseWtcpHeader = function(offset, data) {
        var int8View = new Uint8Array(data, offset, 4);
        var h = this.byteReader(int8View, 4, 0);
        return {
            version: this.bitReader(h, 31, 3, 4) + 1,
            type: this.bitReader(h, 28, 3, 4),
            sequence: this.bitReader(h, 25, 10, 4),
            payloadLength: this.bitReader(h, 15, 16, 4)
        };
    };

    WtcpUtil.prototype.promiseTimeout = function(ms, promise) {

        // create a promise that rejects in <ms> milliseconds
        
        let timerId; 
        let timedPromise = new Promise((resolve, reject) => 
            {
                 timerId = setTimeout(() => { reject('timeout in ' + ms + ' ms'); }, ms); 
            }); 

        // returns a race between our timeout and the passed in promise

        return Promise.race([timedPromise, promise])
                .then( (result) => { clearTimeout(timerId); 
                                     return result;
                                    })
                .catch((err) => { 
                    console.log("ALERT : race exception : ", err)
                    return err;});
    };

    WtcpUtil.prototype.EndpointFlags = function() {
        this.Moderator = false;
        this.Speaking = false;
        this.Typing = false;
        this.AudioTxMute = false;
        this.TextMute = false;
        this.Unavailable = false;
        this.Visible = false;
        this.AudioRxMute = false;
        this.TxSilence = false;
        this.RxSilence = false;
        this.EmergencyTx = false;
        this.Self = false;
        this.P2P = false;
        this.Gone = false;

        return this;
    };

    WtcpJs.EndpointFlags = WtcpUtil.prototype.EndpointFlags;

    module.exports = new WtcpUtil();
})();